import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Products from './components/Product';
import './styles/styles.css';
import Footer from './components/Footer';
import Services from './components/Services';
import ProductsDetails from './components/ProductsDetails';
import Bar from './components/Bar';
import Projects from './components/Projects';
import ServiceDetails from './components/ServiceDetails';
import Scroll from './components/Scroll';
import ProjectDetails from './components/ProjectDetails';
import { Contact } from './components/Contact';
import Trackvisibilty from './components/Trackvisibilty';
import ScrollToTop from './components/ScrollToTop';
import FixedNavbar from './components/FixedNavbar';
import { useState, useEffect } from "react";
import BackButton2 from './components/Backbutton2';

function App() {
  const [showFixedNavbar, setShowFixedNavbar] = useState(false);

  useEffect(() => {
    // Event listener for scrolling
    const handleScroll = () => {
      if (window.scrollY > 100) { // Adjust this value as needed
        setShowFixedNavbar(true);
      } else {
        setShowFixedNavbar(false);
      }
    };

    // Add the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Router>
       <ScrollToTop />
      <Bar/>
    <Navbar />
    {showFixedNavbar && <FixedNavbar />} {/* Render FixedNavbar based on scroll */}      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/service" element={<Services />} />
        <Route path="/Projects" element={<Projects />} />
        
        <Route path="/contact" element={<Contact />} />
        <Route path="/trk" element={<Trackvisibilty />} />
        <Route path="/serviceDetails/:serviceId" element={<ServiceDetails />} />
        <Route path="/details/:productId" element={<ProductsDetails />} />
        <Route path="/Projectdetails/:projectId" element={<ProjectDetails />} />
      </Routes>
      <Footer/>
      <Scroll/>
    </Router>
  );
}

export default App;
